import React from 'react';
import { Box, Typography, Stack, Button, CircularProgress } from '@mui/material';
import { OpenInNew, Download as DownloadIcon, Delete as DeleteIcon } from '@mui/icons-material';

interface DocumentActionsSectionProps {
  canDelete: boolean;
  isDownloading: boolean;
  isViewing: boolean;
  isDeleting: boolean;
  onView: () => void;
  onDownload: () => void;
  onDelete: () => void;
}

export const DocumentActionsSection: React.FC<DocumentActionsSectionProps> = ({
  canDelete,
  isDownloading,
  isViewing,
  isDeleting,
  onView,
  onDownload,
  onDelete,
}) => (
  <Box
    sx={{
      p: 2,
      backgroundColor: '#f8fafc',
      borderRadius: 2,
      border: '1px solid #e2e8f0',
    }}
  >
    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, color: '#1e293b' }}>
      Available Actions
    </Typography>
    <Stack direction="row" spacing={2} flexWrap="wrap">
      <Button
        variant="contained"
        startIcon={isViewing ? <CircularProgress size={16} color="inherit" /> : <OpenInNew />}
        onClick={onView}
        disabled={isViewing || isDownloading || isDeleting}
        sx={{
          backgroundColor: '#3b82f6',
          '&:hover': {
            backgroundColor: '#2563eb',
          },
        }}
      >
        {isViewing ? 'Loading...' : 'View Document'}
      </Button>
      <Button
        variant="outlined"
        startIcon={isDownloading ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />}
        onClick={onDownload}
        disabled={isDownloading || isViewing || isDeleting}
        sx={{
          borderColor: '#3b82f6',
          color: '#3b82f6',
          '&:hover': {
            backgroundColor: '#eff6ff',
            borderColor: '#2563eb',
          },
        }}
      >
        {isDownloading ? 'Downloading...' : 'Download'}
      </Button>
      {canDelete && (
        <Button
          variant="outlined"
          startIcon={isDeleting ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
          onClick={onDelete}
          disabled={isDeleting || isViewing || isDownloading}
          sx={{
            borderColor: '#dc2626',
            color: '#dc2626',
            '&:hover': {
              backgroundColor: '#fef2f2',
              borderColor: '#b91c1c',
            },
          }}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      )}
    </Stack>
  </Box>
);

export default DocumentActionsSection;
